var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57302 5.36709C9.50237 5.14822 9.29836 5 9.0678 5C8.83777 5 8.63377 5.14822 8.56258 5.36709L7.84699 7.56966H5.53127C5.30124 7.56966 5.09724 7.71734 5.02605 7.93675C4.95486 8.15562 5.03296 8.39522 5.2189 8.53069L7.09261 9.89175L6.37702 12.0943C6.30583 12.3132 6.38393 12.5528 6.56986 12.6883C6.75633 12.8232 7.00815 12.8232 7.19461 12.6883L9.0678 11.3267L10.9415 12.6883C11.128 12.8232 11.3798 12.8232 11.5663 12.6883C11.7522 12.5528 11.8303 12.3132 11.7591 12.0943L11.0435 9.89175L12.9172 8.53069C13.1032 8.39522 13.1813 8.15562 13.1101 7.93675C13.0389 7.71734 12.8349 7.56966 12.6049 7.56966H10.2886L9.57302 5.36709Z",
    fill: "#FAAF40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.607fda0139fa3a28170d028711e2cc3d.svg";
export { ForwardRef as ReactComponent };